import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRokuComponent } from './simple-icons-roku.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRokuComponent ],
    exports:      [ SimpleIconsRokuComponent ],
    bootstrap:    []
})
export class SimpleIconsRokuModule {}
